<h1 mat-dialog-title>
  {{ injectData.dialogTitle }}
</h1>
<form #form="ngForm" [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.name" />
        <mat-error [control]="addEditForm.controls.name"></mat-error>
      </mat-form-field>

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="typeDropdownSettings"
          [options]="typeDropdownOptions"
          [formControl]="addEditForm.controls.type"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      @if (
        addEditForm.controls.type.value.length && addEditForm.controls.type.value[0].id === ECustomFilterType.manual
      ) {
        <div class="col-12">
          <app-datatable
            [configurationInput]="{
              areCheckboxesEnabled: false,
              isClientSide: true,
              isDraggable: true,
              isHeaderRowEnabled: false,
              isLoaderEnabled: false,
              isPaginationEnabled: false,
              isSearchEnabled: false,
            }"
            [rowData]="orderedPredefinedCustomFilterMapRows()"
            [columns]="widgetRequestMapDatatableColumns"
            [total]="10000"
            [customColumnDef]="[
              { name: 'dropdownId', template: idInput, isSortable: false },
              { name: 'dropdownName', template: nameInput, isSortable: false },
              { name: 'delete', template: rowDelete, isSortable: false },
            ]"
            (rowOrderChange)="predefinedCustomFilterMapRowOrders.set($event)"
          />
          <div class="mt-2 mb-3">
            <button mat-stroked-button (click)="addPredefinedOption()" type="button">
              <mat-icon>add</mat-icon>
              {{ 'button.addContext' | translate: { context: ('field.option' | translate) } }}
            </button>
          </div>
        </div>
      } @else if (
        addEditForm.controls.type.value.length && addEditForm.controls.type.value[0].id === ECustomFilterType.external
      ) {
        <div class="col-12">
          <mat-dropdown
            [configurationInput]="widgetRequestDropdownSettings"
            [options]="store.widgetRequests()"
            [formControl]="apiForm.controls.widgetRequestId"
            [isFormSubmitted]="form.submitted"
          >
          </mat-dropdown>
        </div>

        <div class="col-12 mb-4">
          <button
            mat-stroked-button
            type="button"
            [disabled]="pathOptionsStatus() !== ELoadStatus.success"
            (click)="openEndpointPreview()"
          >
            <mat-icon>visibility</mat-icon>
            {{ 'button.endpointPreview' | translate }}
          </button>
        </div>

        <div class="col-12">
          <mat-dropdown
            [configurationInput]="valueKeyDropdownSettings()"
            [options]="pathOptionsOfSelectedResource()"
            [isLoading]="pathOptionsStatus() === ELoadStatus.loading"
            [formControl]="apiForm.controls.dropdownIdPath"
            [isFormSubmitted]="form.submitted || pathOptionsStatus() === ELoadStatus.failure"
          >
          </mat-dropdown>
        </div>

        <div class="col-12">
          <mat-dropdown
            [configurationInput]="labelKeyDropdownSettings()"
            [options]="pathOptionsOfSelectedResource()"
            [isLoading]="pathOptionsStatus() === ELoadStatus.loading"
            [formControl]="apiForm.controls.dropdownNamePath"
            [isFormSubmitted]="form.submitted || pathOptionsStatus() === ELoadStatus.failure"
          >
          </mat-dropdown>
        </div>
      }
    </div>
    @for (error of store.inUseData(); track error) {
      <app-info-message
        [icon]="'error-outline'"
        [text]="('page.settings.customFilter.' + error[0] | translate) + ' ' + error[1]"
      ></app-info-message>
    }
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ injectData.submitButtonText }}
    </button>
  </mat-dialog-actions>
</form>

<ng-template #nameInput let-row="row">
  <mat-form-field class="column-name-input" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'field.name' | translate }}</mat-label>
    <input matInput [formControl]="row.dropdownName" />
    <mat-error [control]="row.dropdownName"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template #idInput let-row="row">
  <mat-form-field class="column-name-input" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'field.id' | translate }}</mat-label>
    <input matInput [formControl]="row.dropdownId" />
    <mat-error [control]="row.dropdownId"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template #rowDelete let-row="row">
  <button
    mat-mini-fab
    type="button"
    class="v-middle"
    (click)="deleteMapRow(row.id)"
    [disabled]="orderedPredefinedCustomFilterMapRows().length < 2"
    [matTooltip]="'button.remove' | translate"
  >
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>
